/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import { PostMynaJobsRequestBody, PostMynaJobsRequestBodyFromJSON, PostMynaJobsRequestBodyToJSON } from "../models";

export interface PostPatientMynaJobsRequest {
  types: Array<PostPatientMynaJobsTypesEnum>;
  postMynaJobsRequestBody: PostMynaJobsRequestBody;
  familyAccountId?: number;
}

/**
 *
 */
export class MynaJobApi extends runtime.BaseAPI {
  /**
   * Import the patient\'s own personal health record from myna portal API using JWT
   */
  async postPatientMynaJobsRaw(
    requestParameters: PostPatientMynaJobsRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.types === null || requestParameters.types === undefined) {
      throw new runtime.RequiredError(
        "types",
        "Required parameter requestParameters.types was null or undefined when calling postPatientMynaJobs."
      );
    }

    if (requestParameters.postMynaJobsRequestBody === null || requestParameters.postMynaJobsRequestBody === undefined) {
      throw new runtime.RequiredError(
        "postMynaJobsRequestBody",
        "Required parameter requestParameters.postMynaJobsRequestBody was null or undefined when calling postPatientMynaJobs."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.types) {
      queryParameters["types"] = requestParameters.types;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/myna-jobs`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PostMynaJobsRequestBodyToJSON(requestParameters.postMynaJobsRequestBody),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Import the patient\'s own personal health record from myna portal API using JWT
   */
  async postPatientMynaJobs(requestParameters: PostPatientMynaJobsRequest, initOverrides?: RequestInit): Promise<void> {
    await this.postPatientMynaJobsRaw(requestParameters, initOverrides);
  }
}

/**
 * @export
 * @enum {string}
 */
export enum PostPatientMynaJobsTypesEnum {
  Medication = "medication",
  SpecificHealthCheckup = "specific_health_checkup",
  MedicalExpenseNotification = "medical_expense_notification",
}
